import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:block bg-foreground relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1611042553484-d61f84d22784" alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute bottom-10 left-10 text-white">
          <div className="font-heading font-black text-5xl tracking-tighter uppercase">Bundles and Blends<span className="text-accent">.</span></div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-accent mb-2">Welcome back</div>
          <h1 className="font-heading font-black text-4xl uppercase tracking-tighter mb-8">Sign In</h1>
          {error && <div data-testid="login-error" className="bg-destructive/10 text-destructive text-sm p-3 mb-4 border border-destructive/20">{error}</div>}
          <label className="block text-xs font-bold uppercase tracking-[0.2em] mb-2">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-input px-4 py-3 mb-5 outline-none focus:ring-2 focus:ring-ring text-sm" />
          <label className="block text-xs font-bold uppercase tracking-[0.2em] mb-2">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-input px-4 py-3 mb-6 outline-none focus:ring-2 focus:ring-ring text-sm" />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-foreground text-background py-4 text-xs font-bold uppercase tracking-[0.25em] hover:bg-black/80 transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
          <p className="mt-6 text-sm text-muted-foreground text-center">No account? <Link to="/register" className="text-foreground font-medium hover:text-accent">Create one</Link></p>
        </form>
      </div>
    </div>
  );
}
